import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/baseUi/avatar"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"

type ChatToastProps = {
  image?: string
  authorName: string
  message: string
  onClick: () => void
  className?: string
} & React.ComponentProps<"div">

export function ChatToast({ authorName, message, image, onClick, className, ...props }: ChatToastProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex cursor-pointer flex-row items-center gap-2.5 bg-neutral-50",
        "min-h-12.5 rounded-4xl px-4 py-2",
        className,
      )}
      {...props}
    >
      <Avatar className={cn("size-10")}>
        <AvatarImage src={image} className={cn("object-cover")} alt={authorName} />
        <AvatarFallback className={cn("bg-neutral-200")}>
          <Text className="font-semibold text-neutral-700">{authorName.charAt(0).toUpperCase()}</Text>
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-1 flex-col">
        <Text fontStyle="BL">{authorName}</Text>
        {message && (
          <Text fontStyle="BS" className="line-clamp-2">
            {message}
          </Text>
        )}
      </div>
    </div>
  )
}
